var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineManageGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1,20h16.64c1.46,0,2.72-1.02,3-2.46l1.31-7c.16-.87-.07-1.76-.64-2.44-.58-.7-1.45-1.1-2.36-1.1h-4.77V3c0-2.06-2.11-3-4.08-3-.55,0-1,.45-1,1,0,1.91-.34,3.91-.72,4.28l-2.79,2.72H1c-.55,0-1,.45-1,1v10c0,.55.45,1,1,1Zm6-10.58l2.77-2.7c.93-.91,1.21-3.11,1.3-4.58.54.13,1.11.38,1.11.87v5c0,.55.45,1,1,1h5.77c.32,0,.62.14.82.38.19.22.26.52.21.8l-1.3,7c-.11.49-.55.83-1.04.82H7v-8.58Zm-5,.58h3v8h-3v-8Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineManageGood);
export default __webpack_public_path__ + "static/media/line_manage_good.a639bae21912451428ac162f2f6e7e0d.svg";
export { ForwardRef as ReactComponent };